'use client';

import { Tab } from '@mui/material';

import { styled } from '../../styles';
import { Theme } from '../../theme';

import { TabProps, TabSize } from './types';

const getPadding = (theme: Theme, size?: TabSize) => {
  if (size === 'large') {
    return theme.spacing(4, 5);
  }

  if (size === 'medium') {
    return theme.spacing(3, 4);
  }

  return theme.spacing(2, 3);
};

export const StyledTab = styled(Tab)<TabProps>(({ theme, size }) => ({
  padding: getPadding(theme, size),
}));
